import * as React from 'react';
import type { RatingSeries } from '@chess/api-insights';
import { CardAside, CardEmpty } from '@chess/api-dashboard/react';
import { RatingLines, SkeletonPlot, TextSkeleton, type CardProps, type FilterLink } from '@chess/api-insights/charts';

export type RatingCardProps = CardProps<{ rating: RatingSeries[]; from: number; to: number }, { link?: FilterLink }>;

/**
 * One line per time class played in the period; a class with one game is a
 * point. The legend gives each class's current rating; no change note
 * (removed 2026-10-05). The chart grows to the card's full height, which is
 * its row's (2026-10-05). The body of the card: the section draws its
 * frame and title (`registerCard`, @chess/api-dashboard).
 */
export const RatingCard: React.FC<RatingCardProps> = (props) => {
  if (props.loading)
    return (
      <>
        <CardAside>Last 30 days</CardAside>
        <div className="lines lines-fill">
          <SkeletonPlot fill label="Loading the rating trend" />
          <ul className="legend-row" aria-label="Legend">
            <li>
              <TextSkeleton sample="Blitz 1490" />
            </li>
          </ul>
        </div>
      </>
    );
  const { rating, from, to, link } = props;
  return (
    <>
      <CardAside>Last 30 days</CardAside>
      {rating.length ? <RatingLines fill series={rating} from={from} to={to} link={link} /> : <CardEmpty>No rated games in the last 30 days.</CardEmpty>}
    </>
  );
};
